import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer({
  className = ''
}: {
  className?: string;
}) {
  const [timeLeft, setTimeLeft] = useState(600);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const storedStartTime = sessionStorage.getItem('timerStartTime');
    const now = Date.now();
    let startTime: number;
    if (storedStartTime) {
      startTime = parseInt(storedStartTime, 10);
    } else {
      startTime = now;
      sessionStorage.setItem('timerStartTime', startTime.toString());
    }
    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = Math.max(0, 600 - elapsed);
      setTimeLeft(remaining);
      if (remaining === 0) {
        setIsExpired(true);
      }
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  if (isExpired) {
    return <div className={`text-red-400 font-medium ${className}`} data-id="element-32">
        Tiempo agotado
      </div>;
  }
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const isLow = timeLeft < 120; // Under 2 minutes
  return <motion.div className={`font-mono font-bold tracking-wider ${isLow ? 'text-red-400' : 'text-purple-300'} ${className}`} animate={isLow ? {
    opacity: [1, 0.5, 1]
  } : {}} transition={isLow ? {
    repeat: Infinity,
    duration: 1
  } : {}} data-id="element-33">
      {minutes.toString().padStart(2, '0')}:
      {seconds.toString().padStart(2, '0')}
    </motion.div>;
}